import { z } from "zod";
import { NewFinancialStage } from "../shared";

export const CompanySchema = z.object({
  id: z.number(),
  name: z.string().nullable(),
  logoUrl: z.string().nullable(),
  headline: z.string().nullable(),
  foundingDate: z.coerce.date().nullable(),
  financialStage: z.nativeEnum(NewFinancialStage).nullable(), // TODO -- if we don't have data do we return Private ?
  totalFunding: z.coerce.bigint().nullable(), // TODO -- change to nullable when new Aloglia index is created - M
  valuation: z.coerce.bigint().nullable(),
  country: z.string().nullable(),
  state: z.string().nullable(),
  city: z.string().nullable(),
  website: z.string().nullable(),
  linkedInUrl: z.string().nullable(),
  harmonicInvestors: z
    .array(
      z.object({
        name: z.string(),
        type: z.enum(["organization", "individual"]),
        imageUrl: z.string().nullable()
      })
    )
    .default([]),

  // TODO: Same here as for investors
  team: z.array(z.any()).nullish() // Empty array for now, type can be defined later
});

export const CompaniesSchema = z.array(CompanySchema);
